import React from 'react';
import SizeBox from '../../../element/sizebox';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';
import { findIndex } from 'underscore';

const $ = jQuery;

class SizeBoxPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleSizeBoxValue = this.handleSizeBoxValue.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.filterable = API.filterable === 'true' ? true : false;

    this.state = {
      'values': [],
      'options': [],
      'toogle': true,
    };
    this.changeToogle = this.changeToogle.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    this.block = nextprops.block;
  }
  handleSizeBoxValue(values) {
    this.setState({ 'values': _.pluck(values, 'slug') });
    url.push({
      'searchItem': this.searchItem,
      'searchType': this.searchType,
      'searchField': 'sizeBox',
      values,
    });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  render() {
    this.helperData = clone(this.props.helperData);
    this.block = this.props.block;
    let values = this.state.values;
    const urlData = this.props.urlData;
    if (urlData.hasOwnProperty('pagenumber')) {
      delete urlData['pagenumber'];
    }
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        const previousOptions = this.options;
        this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
        const allUrlData = [];
        window.searchArray.map((item) => {
          if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
            allUrlData.push(item);
          }
        });
        const topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
        let tempOptions = [];
        if (topKey !== null && this.filterable !== true) {
          let selectedOptions = [];
          const self = this;
          if (this.searchItem !== topKey) { // the searchItem is not the top
            if (urlData.hasOwnProperty(self.searchItem)) {
              if (!(_.isArray(urlData[self.searchItem]))) {
                selectedOptions.push(urlData[self.searchItem]); // previous selected Options
              } else {
                selectedOptions = clone(urlData[self.searchItem]);
              }
            }
            this.options.map((item) => {
              this.props.previewData.data.map((singleItem) => {
                const isAlreadyATakenOption = findIndex(tempOptions, { slug: item.slug });
                const optionIndex = _.indexOf(singleItem.terms[this.searchItem], item.slug);
                if ((optionIndex !== -1 && isAlreadyATakenOption === -1)) {
                  tempOptions.push(item);
                }
              });
              const selectedIndex = _.indexOf(selectedOptions, item.slug);
              if (selectedIndex !== -1) {
                const temp = [];
                temp.push(item);
                tempOptions = _.union(tempOptions, temp);
              }
            });
            this.options = clone(tempOptions);
          } else {
            if (Object.keys(urlData).length === 1) {
              this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
            }
            if (Object.keys(urlData).length !== 1) {
              if (previousOptions !== undefined) {
                this.options = clone(previousOptions);
              }
            }
          }
        }
      }
      // url case
      if (this.props.urlData.hasOwnProperty(this.searchItem)) {
        if (this.state.values.length < 1) {
          values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
        }
      } else {
        values = [];
      }
    }

    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    const sizeBoxClassName = this.props.block.dynamicNameClassSizeBox;
    const HelperClass = this.state.toogle ? 'single-component' : '';

    return (<div className={sizeBoxClassName}>
        <Title
          title ={this.props.block.title}
          subtitle ={this.props.block.subtitle}
          toogle = {this.state.toogle}
          onToogle = {this.changeToogle}
          selectedToogleViewType = {this.props.block.selectedToogleViewType}
        />
        <div className={HelperClass}>
        {this.options !== undefined && this.options.length ? <div>
          <SizeBox
            isOpenElement={ifOpen}
            type={this.props.block.selectedViewType}
            options={this.options}
            value={values}
            onSelectSizeBox={this.handleSizeBoxValue}
          />
        </div> : null}
        { this.options !== undefined ? <div>
          {this.options.length === 0 && this.state.toogle ?
            <div className={'rq-no-attributes-found' + ' ' + ifOpen}>
              <h3>{API.LANG.NO_ATTR_FOUND}</h3>
            </div> : ''}
          </div> : null
        }
        </div>
      </div>);
  }
}

SizeBoxPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'previewData': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default SizeBoxPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/default/sizeboxpreview.js
 **/